<template>
	<div class="auth" v-if="type == 'signup'">
		<div class="auth-slide d-none d-lg-block col-lg-9"></div>
		<div class="inputs float-right col-12 col-lg-5">
			<div class="float-left col-12 col-md-10 offset-md-1">
				<LiveLogo />
				<div class="text-center mt-3 pb-1">
					<strong class="d-block mb-1">{{
						$t("view.auth.wellcome")
					}}</strong>
				</div>
				<!--<Login v-if="type == 'login'" @changeType="onChangeType" />-->
				<SignUp v-if="type == 'signup'" @changeType="onChangeType" />
				<!--<ForgetPassword v-if="type == 'forgetPassword'" @changeType="onChangeType" />-->
			</div>
		</div>
	</div>
	<LiveLogoLoading v-else />
</template>
<script>
import store from "@/store";
import LiveLogo from "@/components/LiveLogo";
import LiveLogoLoading from "@/components/LiveLogoLoading";
import LanguageSelector from "@/components/LanguageSelector";
import Login from "./auth/Login";
import SignUp from "./auth/SignUp";
import ForgetPassword from "./auth/ForgetPassword";
import Mgr from "../oidc/SecurityService";

export default {
	components: {
		LiveLogo,
		LiveLogoLoading,
		LanguageSelector,
		Login,
		SignUp,
		ForgetPassword
	},

	data() {
		return {
			loading: true,
			mgr: new Mgr(),
			type: "login"
		};
	},

	beforeMount() {
		if (this.$route.query.t == "signup") {
			this.type = "signup";
		} else {
			this.mgr.getSignedIn().then(
				signIn =>
				{
					if (signIn == true && store.customer) {
						this.$router.push({
							name: "club",
							params: { action: "dashboard" }
						});
					} else if (signIn == true) {
						this.type = "signup";
					}
				},
				err => {
					console.log(err);
				}
			);
		}

		//if (store.token !== null && store.customer != null)
		//{
		//    const redirectPath = this.$route.query.redirect || { name: 'club', params: { action: 'dashboard' } };
		//    this.$router.push(redirectPath);
		//}
	},

	methods: {
		onChangeType(value) {
			this.type = value;
		}
	}
};
</script>
<style>
.auth {
	position: relative;
	width: 100%;
	height: 100%;
	background: #f8f8f8;
	float: left;
}

.auth-slide {
	height: 100%;
	background-color: #f8f8f8;
}

.inputs {
	height: auto;
	min-height: 100%;
	padding-top: 50px;
	padding-bottom: 100px;
	position: relative;
}

.auth-slide {
	background-color: #f8f8f8;
	background-image: url("../assets/image/auth-slider-2.png");
	background-position: center right;
	background-size: cover;
	position: fixed;
	top: 0;
	left: 0;
}

.inputs .lang {
	position: absolute;
	bottom: 10px;
	right: 10px;
	font-size: 12px;
}

.custom-btn {
	background: #961428 !important;
	height: 40px;
	color: #fff;
}

.custom-outline-btn {
	background: #f8f8f8 !important;
	border: #961428 solid 1px !important;
	height: 40px;
	color: #961428;
}

.custom-control-label {
	padding-right: 20px;
}

.custom-control-label::after,
.custom-control-label::before {
	right: 0rem !important;
	left: inherit;
}

.custom-control-input:checked ~ .custom-control-label::before {
	border-color: rgb(245, 200, 66);
	background-color: rgb(245, 200, 66);
}

.red {
	color: #bb0013;
}

.errors {
	font-size: 13px;
	width: 100%;
	float: left;
}
</style>
